import { useEffect, useState } from 'react';

const STORAGE_KEY = 'galaxyxon_ref';

const readUrlRef = () => {
  if (typeof window === 'undefined') return '';
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref') || params.get('referral') || params.get('sponsor');
  return ref && /^\d+$/.test(ref) ? ref : '';
};

const readStoredRef = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return '';
    return /^\d+$/.test(raw) ? raw : '';
  } catch {
    return '';
  }
};

/**
 * Captures `?ref=ID` from the current URL and persists it to localStorage.
 * Returns the currently-effective referral id (URL > localStorage > '').
 *
 *  - capture: if the URL has a valid ref, save it (overwrites any stored value).
 *  - read:    URL takes priority, then storage, then empty.
 */
export const useReferral = () => {
  const [ref, setRef] = useState(() => readUrlRef() || readStoredRef());

  useEffect(() => {
    const fromUrl = readUrlRef();
    if (fromUrl) {
      try { localStorage.setItem(STORAGE_KEY, fromUrl); } catch {}
      setRef(fromUrl);
    } else {
      const stored = readStoredRef();
      if (stored) setRef(stored);
    }
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clearRef = () => {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
    setRef('');
  };

  return { ref, clearRef };
};
